import React, { useEffect, useState } from 'react';
import StyledHeadingText from '../components/Fonts/StyledHeadingText';
import Breadcrumbs from '../components/BreadCrumbs';
import { getMandiRate, getScriptLogs, sendSatelliteNotifications, sendSatelliteReport, sendUserExpense } from '../services/scripts';
import { toast } from 'react-toastify';
import Pagination from '../components/tables/pagination/Pagination';
import Table from '../components/tables/Table';
import CustomLoading from '../components/customLoading/CustomLoading';
import { formatDateTime } from '../utils/FormatDateTime';

function Scripts() {
    const [sendUsers, setSendUsers] = useState(false);
    const [sendExpense, setSendExpense] = useState(false);
    const [mandiRate, setMandiRate] = useState(false);
    const [satelliteReport, setSatelliteReport] = useState(false);

    // function to run the scrip
    const runSendUsers = async () => {
        setSendUsers(true);
        await sendUserExpense();
        toast.success("Satellite Notifications Sent...");
    }

    const runSendExpense = async () => {
        setSendExpense(true);
        await sendSatelliteNotifications();
        toast.success("Expense Notifications Sent...");
    }

    const runMandiRate = async () => {
        setMandiRate(true);
        await getMandiRate();
        toast.success("Mandi Rates Updating...");
    }

    const runSatelliteReport = async () => {
        setSatelliteReport(true);
        await sendSatelliteReport();
        toast.success("Satellite reports are sending...");
    }
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [filteredType, setFilteredType] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "S. No.", key: "i" },
        { label: "Total Processed", key: "total_processed" },
        { label: "Send On", key: "created_at" },
        { label: "Notification Name", key: "notification_name" },
        { label: "Script Name", key: "script_name" },
        { label: "Logs", key: "logs" },
    ];

    const pageSize = 100;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            let res = await getScriptLogs();
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Scripts' },
        ]} />
        <div className="py-2 gap-2 items-center">
            <StyledHeadingText text="Click on the Script you want to Run" size="mb-4" />
            <div className="flex flex-wrap gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
                {/* Send Satellite Notifications Button */}
                <button
                    onClick={!sendUsers ? runSendUsers : undefined}
                    disabled={sendUsers}
                    className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 flex items-center
      ${sendUsers
                            ? "bg-gray-200 text-gray-600 cursor-not-allowed"
                            : "bg-primary hover:bg-primary-dark text-white shadow hover:shadow-md"
                        }`}
                >
                    {sendUsers ? (
                        <>
                            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Sending...
                        </>
                    ) : (
                        "Send Satellite Notifications"
                    )}
                </button>

                {/* Send Expense Notifications Button */}
                <button
                    onClick={!sendExpense ? runSendExpense : undefined}
                    disabled={sendExpense}
                    className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 flex items-center
      ${sendExpense
                            ? "bg-gray-200 text-gray-600 cursor-not-allowed"
                            : "bg-blue-600 hover:bg-blue-700 text-white shadow hover:shadow-md"
                        }`}
                >
                    {sendExpense ? (
                        <>
                            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Sending...
                        </>
                    ) : (
                        "Send Expense Notifications"
                    )}
                </button>

                {/* Update Mandi Rate Button */}
                <button
                    onClick={!mandiRate ? runMandiRate : undefined}
                    disabled={mandiRate}
                    className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 flex items-center
      ${mandiRate
                            ? "bg-gray-200 text-gray-600 cursor-not-allowed"
                            : "bg-green-600 hover:bg-green-700 text-white shadow hover:shadow-md"
                        }`}
                >
                    {mandiRate ? (
                        <>
                            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Updating...
                        </>
                    ) : (
                        "Update Mandi Rate"
                    )}
                </button>

                {/* Send Satellite Reports Button */}
                <button
                    onClick={!satelliteReport ? runSatelliteReport : undefined}
                    disabled={satelliteReport}
                    className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 flex items-center
      ${satelliteReport
                            ? "bg-gray-200 text-gray-600 cursor-not-allowed"
                            : "bg-purple-600 hover:bg-purple-700 text-white shadow hover:shadow-md"
                        }`}
                >
                    {satelliteReport ? (
                        <>
                            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Sending...
                        </>
                    ) : (
                        "Send Satellite Reports"
                    )}
                </button>
            </div>
        </div >
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.results?.map((item, index) => (
                            {
                                i: <p>{index + 1}</p>,
                                total_processed: <p>{item.total_processed}</p>,
                                notification_name: <span className='flex flex-row gap-1 items-center'><p className="max-w-36 truncate cursor-help" title={item.notification_name}>{item.notification_name}</p></span>,
                                message: <span className='flex flex-row gap-1 items-center'><p className="max-w-40 truncate cursor-help" title={item.message}>{item.message}</p></span>,
                                created_at: <p>{formatDateTime(item.created_at)}</p>,
                                script_name: <span className='flex flex-row gap-1 items-center'><p className="max-w-32 truncate cursor-help" title={item.script_name}>{item.script_name}</p></span>,
                                logs: <span className='flex flex-row gap-1 items-center'><p className="max-w-4xl truncate cursor-help" title={item.logs}>{item.logs}</p></span>,
                            }))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}

                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                /> : <></>
        }
    </>
    );
}

export default Scripts;